import React from 'react';
import { FadeIn } from './FadeIn';
export function About() {
  const stats = [{
    value: '20+',
    label: 'Years Experience',
    color: '#00E5FF'
  }, {
    value: '$10M+',
    label: 'Portfolio Managed',
    color: '#7C3AED'
  }, {
    value: '25+',
    label: 'Global Team Resources',
    color: '#E11D74'
  }, {
    value: '8+',
    label: 'Regulatory Frameworks',
    color: '#C8A96A'
  }];
  return <section id="about" className="relative py-24 md:py-32 bg-navy overflow-hidden" data-id="element-13">
      {/* Background glows */}
      <div className="absolute top-1/4 right-0 w-[500px] h-[500px] rounded-full opacity-20 blur-3xl pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(0,229,255,0.5) 0%, rgba(0,229,255,0) 70%)'
    }} data-id="element-14"></div>
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] rounded-full opacity-20 blur-3xl pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(124,58,237,0.5) 0%, rgba(124,58,237,0) 70%)'
    }} data-id="element-15"></div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-16">
        <FadeIn data-id="element-17">
          <div className="text-xs uppercase tracking-widest font-medium mb-6" style={{
          background: 'linear-gradient(90deg, #00E5FF, #C8A96A)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text'
        }} data-id="element-18">
            Executive Profile
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20" data-id="element-19">
          <div className="lg:col-span-5" data-id="element-20">
            <FadeIn data-id="element-21">
              <h3 className="text-3xl md:text-4xl lg:text-5xl font-serif text-softwhite leading-tight" data-id="element-22">
                Aligning business strategy, risk frameworks, and{' '}
                <span style={{
                background: 'linear-gradient(135deg, #00E5FF, #7C3AED)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }} data-id="element-23">
                  technology
                </span>{' '}
                at global scale.
              </h3>
            </FadeIn>
          </div>

          <div className="lg:col-span-7" data-id="element-24">
            <FadeIn delay={0.2} data-id="element-25">
              <div className="space-y-6 text-softwhite/70 font-light leading-relaxed text-base md:text-lg" data-id="element-26">
                <p data-id="element-27">
                  Sandra J. Gabriel is a results-driven risk and technology
                  leader with over 20 years of experience in enterprise risk
                  management, regulatory compliance, and technology
                  transformation within global financial services organizations.
                </p>
                <p data-id="element-28">
                  She has a proven track record of aligning business strategy,
                  risk frameworks, and technology initiatives to strengthen
                  governance, regulatory readiness, and operational resilience.
                  Her leadership spans top-tier institutions including
                  Citigroup, Credit Suisse, Merrill Lynch, Hewlett-Packard, and
                  Lucent Technologies' Bell Laboratories.
                </p>
                <p data-id="element-29">
                  Sandra leads cross-functional teams, manages large-scale
                  transformation programs, and delivers strategic reporting and
                  oversight for senior leadership and board stakeholders — with
                  deep expertise across regulatory frameworks including
                  SOX-BEAT, MiFID, FATCA, FINMA, FINRA 4210, IOSCO, and
                  Brexit-related compliance.
                </p>
              </div>
            </FadeIn>
          </div>
        </div>

        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6" data-id="element-30">
          {stats.map((stat, index) => <FadeIn key={index} delay={0.3 + index * 0.1} data-id="element-31">
              <div className="relative p-6 md:p-8 rounded-2xl bg-white/[0.03] backdrop-blur-sm border border-white/10 hover:border-white/20 transition-all duration-500 overflow-hidden group" data-id="element-32">
                <div className="absolute -top-12 -right-12 w-32 h-32 rounded-full opacity-30 blur-2xl group-hover:opacity-60 transition-opacity duration-500" style={{
              background: `radial-gradient(circle, ${stat.color}99 0%, transparent 70%)`
            }} data-id="element-33"></div>
                <div className="relative text-3xl md:text-4xl lg:text-5xl font-serif mb-3" style={{
              color: stat.color
            }} data-id="element-34">
                  {stat.value}
                </div>
                <div className="relative text-xs uppercase tracking-wider text-softwhite/60" data-id="element-35">
                  {stat.label}
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}